import { b as u } from "../instance-B0lHmJzq.js";
import { arrowToArray as c } from "../utils/arrowToArray.js";
import { measureExecutionTime as s, isQueryLoggingEnabled as a } from "../utils/measureExecutionTime.js";
const T = async () => {
  const n = u(), o = await n.openConnection();
  async function e(t, i = !1) {
    const m = await o.query(t);
    return i ? c(m) : m;
  }
  async function r() {
    await n.closeConnection(o);
  }
  return { query: e, close: r };
}, w = async (n, o) => await n.withConnection((r) => r.query(o)), g = async (n, o) => await n.withConnection(
  (r) => Promise.all(o.map((t) => r.query(t)))
);
class y extends Error {
  constructor(o, e) {
    super(`Error running query:
        ------------------------
        ${e}
        ------------------------
        ${o.message}`), this.name = "QueryError";
  }
}
async function p(n, o) {
  try {
    const e = await s(w, {
      enabled: a(),
      message: `Running query: 
        ------------------------
        ${n}
        ------------------------
        `,
      onTime: ({ timeMs: r }) => console.log(`Query 
> ${n} <
 took: ${r}ms`)
    })(u(), n);
    return s(c, {
      enabled: a(),
      message: `Transforming 
        ------------------------
        ${n}
        ------------------------ 
        result`,
      onTime: ({ timeMs: r }) => console.log(
        `Transformation of query
                ------------------------
                ${n}
                ------------------------
                took: ${r}ms`
      )
    })(e, o);
  } catch (e) {
    throw new y(e, n);
  }
}
async function h(n, o = []) {
  try {
    const e = await s(g, {
      enabled: a(),
      message: `Running queries 
------------------------ 
${n.join(`
`)} 
------------------------`,
      onTime: ({ timeMs: r }) => console.log(
        `Queries 
------------------------ 
${n.join(`
`)} 
------------------------ 
took: ${r}ms`
      )
    })(u(), n);
    return await Promise.all(
      e.map(
        (r, t) => s(c, {
          enabled: a(),
          message: `Transforming query 
------------------------ 
${n[t]} 
------------------------ 
result`,
          onTime: ({ timeMs: i }) => console.log(
            `Transformation of query 
------------------------ 
${n[t]} 
------------------------ 
took: ${i}ms`
          )
        })(r, o[t])
      )
    );
  } catch (e) {
    throw new y(e, n.join(`
`));
  }
}
export {
  T as createDBConnection,
  h as runQueries,
  p as runQuery
};
